import { createContext } from 'react';

const ApplicationContext = createContext({
  bugsnagClient: null,
});

export default ApplicationContext;
